import { Button, MenuItem } from '@material-ui/core';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
  text-transform: capitalize;
  color: rgba(102, 102, 102, 1);
`;

export const IconWrapper = styled.span`
  margin: 0 8px;
`;

export const StyledMenuItem = styled(MenuItem)`
  color: rgba(102, 102, 102, 1);
  text-transform: capitalize;
`;
